import { components } from "react-select";
import {
  EnquiryIntent,
  EnquiryIntentLabelMap,
} from "features/Enquiries/constants/enquiry.constants";
import type {
  Enquiry,
  EnquirySelectOption,
} from "features/Enquiries/types/enquiry.types";

function intentLabel(intent: string | undefined): string | undefined {
  if (!intent?.trim()) return undefined;
  return (
    EnquiryIntentLabelMap[intent as EnquiryIntent] ?? intent
  );
}

export function buildEnquirySelectDefaultOption(
  enquiry: Enquiry | null | undefined,
): EnquirySelectOption | undefined {
  if (!enquiry?.id) return undefined;
  return {
    value: enquiry.id,
    label: enquiry.code?.trim() || `Enquiry #${enquiry.id}`,
    title: enquiry.title?.trim() || undefined,
    enquiryIntent: enquiry.enquiryIntent,
  };
}

export function enrichEnquirySelectOptionData(
  data: EnquirySelectOption,
  enquiry: Enquiry | null,
): EnquirySelectOption {
  if (!enquiry || Number(data.value) !== enquiry.id) {
    return data;
  }
  return {
    ...data,
    enquiryIntent: data.enquiryIntent ?? enquiry.enquiryIntent,
    title: data.title ?? enquiry.title,
    label:
      (data.label && String(data.label).trim()) ||
      enquiry.code?.trim() ||
      `Enquiry #${enquiry.id}`,
  };
}

export function EnquiryOption(props: any) {
  const data = props.data as EnquirySelectOption;
  const intent = intentLabel(data.enquiryIntent);
  const title = data.title?.trim();

  return (
    <components.Option {...props}>
      <div className="d-flex flex-column py-1">
        <span className="fw-medium text-body">{data.label}</span>
        {title ? (
          <small className="text-muted text-truncate" title={title}>
            {title}
          </small>
        ) : null}
        {intent ? (
          <small className="text-muted">
            Intent: <span className="text-body">{intent}</span>
          </small>
        ) : null}
      </div>
    </components.Option>
  );
}

export function EnquirySingleValue(props: any) {
  const data = props.data as EnquirySelectOption;
  const intent = intentLabel(data.enquiryIntent);
  const title = data.title?.trim();

  return (
    <components.SingleValue {...props}>
      <span className="d-inline-flex flex-column min-w-0">
        <span className="d-inline-flex align-items-center gap-1 text-truncate">
          <span className="text-truncate">{data.label}</span>
          {intent ? (
            <span className="text-muted text-truncate small">· {intent}</span>
          ) : null}
        </span>
        {title ? (
          <small className="text-muted text-truncate">{title}</small>
        ) : null}
      </span>
    </components.SingleValue>
  );
}
